import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExpertProfileComponent } from './pages/expert-profile/expert-profile.component';
import { ExsepComponent } from './exsep.component';
import { ExsepRoutingModule } from './exsep-routing.module';
import { RejectExsepComponent } from './components/reject-exsep/reject-exsep.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxSummernoteModule } from 'ngx-summernote';



@NgModule({
  declarations: [
    ExsepComponent,
    ExpertProfileComponent,
    RejectExsepComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    NgSelectModule,
    MatInputModule,
    MatMenuModule,
    ExsepRoutingModule,
    FormsModule,
    SharedModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    NgxSummernoteModule
  ],
  providers: [
  ]
})
export class ExsepModule {}
